import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/narrow-down-vector.png'


const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline search-headline" }, "タレントを探す", -1)
const _hoisted_3 = { class: "search-box" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "narrow-down-damy" }, null, -1)
const _hoisted_5 = { class: "search-form-box" }
const _hoisted_6 = { class: "narrow-down" }
const _hoisted_7 = /*#__PURE__*/_createVNode("input", {
  class: "narrow-down-input",
  type: "radio",
  name: "option"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "narrow-down-text",
  style: { color: '$onlylive-lg' }
}, "絞り込み", -1)
const _hoisted_9 = { class: "narrow-down-option" }
const _hoisted_10 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "option"
}, null, -1)
const _hoisted_11 = { class: "narrow-down-title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "narrow-down-vector",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          class: "search-form txt",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTalent = $event)),
          placeholder: "タレントを検索..."
        }, null, 512), [
          [_vModelText, _ctx.searchTalent]
        ]),
        _createVNode(_component_font_awesome_icon, {
          class: "search-icon",
          icon: "search"
        })
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.items, (item) => {
        return (_openBlock(), _createBlock("label", _hoisted_9, [
          _hoisted_10,
          _createVNode("span", _hoisted_11, _toDisplayString(item.text), 1)
        ]))
      }), 256))
    ]),
    _hoisted_12
  ]))
}